import { useState } from "react";
import styles from "./Tooltip.module.css";
import BlackTip from "../../assets/icons/BlackTip";

export interface TooltipProps {
  info?: string | string[];
  extraClassName?: string;
}
const Tooltip: React.FC<TooltipProps> = ({ info, extraClassName }) => {
  const [show, setShow] = useState<boolean>(false);

  const handleToggleShow = () => {
    setShow(!show);
  };
  return (
    <div className={extraClassName || ""}>
      <div
        className={`${styles.tooltipWrapper}`}
        onMouseEnter={handleToggleShow}
        onMouseLeave={handleToggleShow}
      >
        <span className={styles.tooltipIcon}>i</span>
        {show && (
          <div className={styles.tooltipPopup}>
            <BlackTip className={styles.tip} />
            {typeof info === "string" ? (
              <span>{info}</span>
            ) : (
              <ul>
                {info?.map((item) => (
                  <li key={item}>
                    <span>.</span>
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Tooltip;
